import { Injectable, ViewContainerRef } from '@angular/core';
import { LMDialogButtonKey, LMUniqueIdService } from '@app/utils';
import { LMKeyboardShortcutsDialogComponent } from '@app/components';
import { SohoModalDialogRef, SohoModalDialogService } from 'ids-enterprise-ng';

@Injectable()
export class LMKeyboardShortcutsDialogService {

  private dialog: SohoModalDialogRef<any> | undefined;
  
  constructor(
    private lmUniqueIdService: LMUniqueIdService,
    private sohoModalDialogService: SohoModalDialogService
  ) { }

  public openKeyboardShortcutsDialog(placeHolder: ViewContainerRef) {
    const dialogId = 'KeyboardShortcuts';
    const buttons = [ {
      id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.OK ]),
      text: Soho.Locale.translate(LMDialogButtonKey.OK),
      click: (e: any, modal: { isCancelled: boolean; close: (arg0: boolean) => void; }) => {
        modal.isCancelled = true;
        modal.close(true);
      },
      isDefault: true
    } ];

    this.dialog = this.sohoModalDialogService
      .modal(LMKeyboardShortcutsDialogComponent, placeHolder, { fullsize: 'responsive' })
      .buttons(buttons)
      .title(Soho.Locale.translate('KeyboardShortcuts'))
      .open();
  }
}